import React from 'react';
import { motion } from 'framer-motion';
import { MoveRight } from 'lucide-react';

const LetsWorkTogether = () => {
	return (
		<section className="relative bg-white py-12 sm:py-16 md:py-20 lg:py-24">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
				<div className="text-center lg:text-left max-w-4xl mx-auto lg:mx-0 max-w-2xl">
					{/* Main Text Content */}
					<motion.p 
						className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-sans font-regular text-[#113861] leading-relaxed mb-8 sm:mb-10 md:mb-12 lg:mb-16"
						initial={{ y: 30, opacity: 0 }}
						whileInView={{ y: 0, opacity: 1 }}
						viewport={{ once: true, amount: 0.3 }}
						transition={{ duration: 0.8, ease: "easeOut" }}
					>
						We believe self-awareness should reflect who you are
						and where you come from. That's why we partner
						with universities to support every student's path;
						from aspiration to actualisation.
					</motion.p>

					{/* Call to Action Button */}
					<motion.button
						className="bg-[#42FF00] hover:bg-[#42FF00] transition-colors duration-300 text-[#000000] font-sans font-medium px-6 sm:px-8 md:px-10 lg:px-12 py-3 sm:py-4 md:py-5 lg:py-6 rounded-lg sm:rounded-xl md:rounded-2xl text-base sm:text-lg md:text-xl lg:text-2xl flex items-center justify-center mx-auto lg:mx-0 space-x-2 sm:space-x-3"
						initial={{ y: 30, opacity: 0 }}
						whileInView={{ y: 0, opacity: 1 }}
						viewport={{ once: true, amount: 0.3 }}
						transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
					>
						<span>Let's Work Together</span>
						<MoveRight className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-black group-hover:translate-x-1 transition-transform duration-200 font-source font-regular" />
					</motion.button>
				</div>
			</div>
			
			{/* Bottom Border */}
			<div className="absolute bottom-0 left-0 right-0 h-px bg-[#113861] opacity-20"></div>
		</section>
	);
};

export default LetsWorkTogether;
